(function() {
    function waitForElem(waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
        let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
        if (timer <= 0) return;
        ((!isVariable && elements.length >= minElements) || (isVariable && (typeof window[waitFor] !== 'undefined'))) ?
        callback(elements):
            setTimeout(waitForElem.bind(null, waitFor, callback, minElements, isVariable, (timer - frequency)), frequency);
    }

    waitForElem('.trustblox-1-viewcart-message', () => {
        const container = document.querySelector('.trustblox-1-viewcart-message');
        if (!container) return;

        const countdownSpan = document.querySelector('#countdown-timer');
        updateCountdown(countdownSpan);
        setInterval(() => updateCountdown(countdownSpan), 1000);
    });

    // Hide next-day box if cart becomes empty
    waitForElem('#content', () => {
        const observer = new MutationObserver(() => {
            const emptyCart = document.querySelector('#content .empty-cart');
            const elements = document.querySelectorAll('.cart-body .prod-icon-crt');
            const deliveryBox = document.querySelector('#content #next-day-delivery-container');
            const searchText = "Arriving soon";

            elements.forEach(el => {
                if (el.textContent.trim() === searchText) {
                    console.log('preorder found');
                    deliveryBox.style.setProperty('display', 'none', 'important');
                    observer.disconnect();
                }
            });
            if (emptyCart) {
                if (deliveryBox) {
                    deliveryBox.style.setProperty('display', 'none', 'important');
                }
                observer.disconnect();
            }
        });

        observer.observe(document.querySelector('#content'), {
            childList: true,
            subtree: true
        });
    });
})();

function updateCountdown(target) {
    if (!target) return;

    const ukDateParts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).formatToParts(new Date());

    const getPart = (type) => parseInt(ukDateParts.find(p => p.type === type).value, 10);
    const ukNow = new Date(
        getPart('year'),
        getPart('month') - 1,
        getPart('day'),
        getPart('hour'),
        getPart('minute'),
        getPart('second')
    );

    const deadline = new Date(ukNow);
    deadline.setHours(14, 0, 0, 0);
    if (ukNow > deadline) {
        deadline.setDate(deadline.getDate() + 1);
    }

    const diffMs = deadline - ukNow;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    let countdownParts = [];
    if (days > 0) countdownParts.push(`${days} Days`);
    // if (hours > 0 || days > 0) countdownParts.push(`${hours} Hrs`);
    if (hours > 0 || days > 0) countdownParts.push(`${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`);
    // if (minutes > 0 || hours > 0 || days > 0) countdownParts.push(`${minutes} Mins`);
    if (minutes > 0 || hours > 0 || days > 0) countdownParts.push(`${minutes} ${minutes === 1 ? 'Min' : 'Mins'}`);
    countdownParts.push(`${seconds} Sec`);

    target.innerHTML = `<span class="countdown-text">${countdownParts.join(' : ')}</span>`;
}